import en from './en';
const ta = {
  getHelp: {
    title: 'உதவி & ஆதரவு பெறுங்கள்',
    subtitle: 'உங்களுக்கு உதவி வேண்டுமா? எங்கள் குழு உங்களுக்கு உதவ இங்கே உள்ளது. தொலைபேசி, மின்னஞ்சல் அல்லது நேரடி அரட்டை மூலம் தொடர்பு கொள்ளுங்கள், அல்லது கீழே உள்ள எங்கள் கேள்விகள் பகுதியை பார்வையிடுங்கள்.',
    contactInfo: 'தொடர்பு தகவல்',
    faq: 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
    faqSubtitle: 'பொதுவான கேள்விகளுக்கான பதில்கள்',
    emergency: 'அவசரம்',
    emergencyDesc: 'உடனடி பாதுகாப்பு கவலைக்காக',
    support: 'ஆதரவு',
    supportDesc: 'பொதுவான கேள்விகள் மற்றும் உதவி',
    technical: 'தொழில்நுட்பம்',
    technicalDesc: 'பயன்பாடு மற்றும் இணையதள சிக்கல்கள்',
    phone: 'தொலைபேசி',
    email: 'மின்னஞ்சல்',
    chat: 'நேரடி அரட்டை',
    available: '24/7 கிடைக்கும்',
    responseTime: '2 மணி நேரத்தில் பதில்',
    responseTimeLong: '24 மணி நேரத்தில் பதில்',
  },
  myIssues: {
    title: 'என் பிரச்சனைகள் & புகார்கள்',
    subtitle: 'நீங்கள் புகாரளித்த பிரச்சனைகள் மற்றும் புகார்கள் நிலையை கண்காணிக்கவும். அவசர உதவிக்கு, தயவுசெய்து உதவி பெறுங்கள் பகுதியைப் பயன்படுத்தவும்.',
    noIssues: 'புகார்கள் அல்லது பிரச்சனைகள் இல்லை.',
    noIssuesDesc: 'உங்களுக்கு உதவி தேவைப்பட்டால், உதவி பெறுங்கள் பகுதியைப் பயன்படுத்தவும் அல்லது புதிய பிரச்சனையை புகாரளிக்கவும்.',
    issueId: 'பிரச்சனை ஐடி',
    priority: 'முன்னுரிமை',
    status: 'நிலை',
    subject: 'பொருள்',
    type: 'வகை',
    filedOn: 'பதிவுசெய்யப்பட்டது',
    inProgress: 'நடந்து கொண்டிருக்கிறது',
    resolved: 'தீர்க்கப்பட்டது',
    closed: 'மூடப்பட்டது',
    high: 'உயர்',
    medium: 'நடுத்தர',
    low: 'குறைவு',
    loading: 'ஏற்றப்படுகிறது...',
    error: 'பிரச்சனைகளை ஏற்றுவதில் பிழை',
  },
  reportIssue: {
    title: 'பிரச்சனையை புகாரளிக்கவும்',
    subtitle: 'பிரச்சனை ஏற்பட்டுள்ளதா? கீழே உள்ள படிவத்தை நிரப்பவும், எங்கள் ஆதரவு குழு 24-48 மணி நேரத்தில் உங்களை தொடர்புகொள்வார்கள்.',
    selectIssueType: 'பிரச்சனை வகையைத் தேர்ந்தெடுக்கவும்',
    selectUrgency: 'அவசரத்தைக் தேர்ந்தெடுக்கவும்',
    beforeSubmit: 'சமர்ப்பிப்பதற்கு முன்:',
    beforeSubmitPoints: [
      'உடனடி பாதுகாப்பு பிரச்சனைக்கு, தயவுசெய்து அவசர சேவைகளை அழைக்கவும்',
      'உங்கள் பயண ரசீது மற்றும் தொடர்புடைய ஸ்கிரீன்ஷாட்களை வைத்திருங்கள்',
      'நாங்கள் 24-48 மணி நேரத்தில் பதிலளிப்போம்'
    ],
    submitIssue: 'பிரச்சனை புகாரளிக்கவும்',
    submitting: 'சமர்ப்பிக்கப்படுகிறது...',
    success: 'உங்கள் பிரச்சனை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது! எங்கள் ஆதரவு குழு விரைவில் அதை தீர்க்கும்.',
    error: 'ஏதோ தவறு ஏற்பட்டது. தயவுசெய்து பின்னர் முயற்சிக்கவும்.',
    loading: 'ஏற்றப்படுகிறது...',
  },
  common: {
    loading: 'ஏற்றப்படுகிறது...',
    error: 'பிழை',
    success: 'வெற்றி',
    submit: 'சமர்ப்பிக்கவும்',
    cancel: 'ரத்து செய்யவும்',
    back: 'பின்னால்',
    next: 'அடுத்தது',
    save: 'சேமிக்கவும்',
    edit: 'திருத்தவும்',
    delete: 'அழிக்கவும்',
    close: 'மூடவும்',
    open: 'திறக்கவும்',
    yes: 'ஆம்',
    no: 'இல்லை',
    required: 'தேவை',
    optional: 'விருப்பம்',
  },
  aboutYou: {
    basicInfo: 'அடிப்படை தகவல்',
    firstName: 'முதல் பெயர்',
    lastName: 'கடைசி பெயர்',
    gender: 'பாலினம்',
    male: 'ஆண்',
    female: 'பெண்',
    other: 'மற்றவை',
    preferNotToSay: 'கூற விரும்பவில்லை',
    dateOfBirth: 'பிறந்த தேதி',
    contactInfo: 'தொடர்பு தகவல்',
    email: 'மின்னஞ்சல் முகவரி',
    phoneNumber: 'தொலைபேசி எண்',
    addressInfo: 'முகவரி தகவல்',
    address: 'முகவரி',
    city: 'நகரம்',
    state: 'மாநிலம்',
    pincode: 'பின் குறியீடு',
    emergencyContact: 'அவசர தொடர்பு',
    emergencyContactNumber: 'தொடர்பு எண்',
    relationship: 'உறவு',
    selectRelationship: 'உறவைத் தேர்ந்தெடுக்கவும்',
    parent: 'பெற்றோர்',
    spouse: 'கணவர்/மனைவி',
    sibling: 'உடன்பிறந்தவர்',
    friend: 'நண்பர்',
   
    saveProfile: 'சுயவிவர தகவலை சேமிக்கவும்',
    phFirstName: 'முதல் பெயரை உள்ளிடவும்',
    phLastName: 'கடைசி பெயரை உள்ளிடவும்',
    phEmail: 'மின்னஞ்சல் முகவரியை உள்ளிடவும்',
    phPhone: 'தொலைபேசி எண்ணை உள்ளிடவும்',
    phAddress: 'உங்கள் முகவரியை உள்ளிடவும்',
    phCity: 'நகரத்தை உள்ளிடவும்',
    phState: 'மாநிலத்தை உள்ளிடவும்',
    phPincode: 'பின் குறியீட்டை உள்ளிடவும்',
    phEmergencyContact: 'அவசர தொடர்பு எண்ணை உள்ளிடவும்',
    save: 'சேமிக்கவும்',
    edit: 'திருத்தவும்',
    firstNameRequired: 'முதல் பெயர் தேவை.',
    firstNameInvalid: 'முதல் பெயர் எழுத்துகள், இடைவெளிகள், அபாஸ்ட்ரோஃப்கள் அல்லது ஹைபன்கள் மட்டுமே இருக்க வேண்டும்.',
    lastNameRequired: 'கடைசி பெயர் தேவை.',
    lastNameInvalid: 'கடைசி பெயர் எழுத்துகள், இடைவெளிகள், அபாஸ்ட்ரோஃப்கள் அல்லது ஹைபன்கள் மட்டுமே இருக்க வேண்டும்.',
    emailRequired: 'மின்னஞ்சல் தேவை.',
    emailInvalid: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.',
    phoneRequired: 'தொலைபேசி எண் தேவை.',
    phoneInvalid: 'தொலைபேசி எண் 10 முதல் 15 இலக்கங்கள் வரை இருக்க வேண்டும்.',
    dobRequired: 'பிறந்த தேதி தேவை.',
    dobInvalid: 'சரியான பிறந்த தேதியை உள்ளிடவும் (YYYY-MM-DD).',
    genderRequired: 'பாலினம் தேவை.',
    addressRequired: 'முகவரி தேவை.',
    cityRequired: 'நகரம் தேவை.',
    cityInvalid: 'நகரம் எழுத்துகள், இடைவெளிகள், அபாஸ்ட்ரோஃப்கள் அல்லது ஹைபன்கள் மட்டுமே இருக்க வேண்டும்.',
    stateRequired: 'மாநிலம் தேவை.',
    stateInvalid: 'மாநிலம் எழுத்துகள், இடைவெளிகள், அபாஸ்ட்ரோஃப்கள் அல்லது ஹைபன்கள் மட்டுமே இருக்க வேண்டும்.',
    countryRequired: 'நாடு தேவை.',
    countryInvalid: 'நாடு எழுத்துகள், இடைவெளிகள், அபாஸ்ட்ரோஃப்கள் அல்லது ஹைபன்கள் மட்டுமே இருக்க வேண்டும்.',
    pincodeRequired: 'பின்கோடு தேவை.',
    pincodeInvalid: 'பின்கோடு 4 முதல் 10 இலக்கங்கள் வரை இருக்க வேண்டும்.',
    emergencyContactRequired: 'அவசர தொடர்பு எண் தேவை.',
    emergencyContactInvalid: 'அவசர தொடர்பு எண் 10 முதல் 15 இலக்கங்கள் வரை இருக்க வேண்டும்.',
    relationshipRequired: 'உறவு தேவை.',
    relationshipInvalid: 'அவசர தொடர்புக்கு சரியான உறவைத் தேர்ந்தெடுக்கவும்.',
    emergencyCountryCodeRequired: 'அவசர நாட்டுக் குறியீடு தேவை.',
    fixErrorsBeforeSaving: 'தயவுசெய்து குறிப்பிடப்பட்ட புலங்களை சரிபார்த்து, உங்கள் சுயவிவரத்தை சேமிப்பதற்கு முன் அனைத்து பிழைகளையும் திருத்தவும்.'
  },
  account: {
    goodMorning: 'காலை வணக்கம்',
    goodAfternoon: 'மதிய வணக்கம்',
    goodEvening: 'மாலை வணக்கம்',
    completeIdentity: 'உங்கள் அடையாளத்தை உறுதிப்படுத்தவும்',
    addEmergencyContact: 'அவசர தொடர்பு தகவலைச் சேர்க்கவும்',
    uploadDriverLicense: 'ஓட்டுநர் சான்றிதழை பதிவேற்றவும்',
    aboutYou: 'உங்களை பற்றி',
    aboutYouDesc: 'உங்களை பற்றி சொல்லுங்கள்',
    identityVerification: 'அடையாள சரிபார்ப்பு',
    identityVerificationDesc: 'உங்கள் அடையாளத்தை உறுதிப்படுத்தவும்',
    offerRides: 'பயணங்களை வழங்கவும்',
    offerRidesDesc: 'உங்கள் ஓட்டுநர் சுயவிவரத்தை அமைக்கவும்',
    findRides: 'பயணங்களை கண்டறியவும்',
    findRidesDesc: 'உங்கள் பயண விருப்பங்கள்',
    appSettings: 'பயன்பாட்டு அமைப்புகள்',
    appSettingsDesc: 'உங்கள் அனுபவத்தை தனிப்பயனாக்கவும்',
    walletPayments: 'பணப்பை & கட்டணங்கள்',
    walletPaymentsDesc: 'உங்கள் பணத்தை நிர்வகிக்கவும்',
    supportGrievances: 'ஆதரவு & புகார்கள்',
    supportGrievancesDesc: 'உதவி பெறவும் அல்லது புகார் அளிக்கவும்',
    actionRequired: 'நடவடிக்கை தேவை',
    completeProfile: 'உங்கள் சுயவிவரத்தை முடிக்கவும்',
    profileHelp: 'உங்கள் சுயவிவரத்தை முடிப்பதன் மூலம் உங்களுக்கு சிறந்த பயணங்களை எங்கள் AI கண்டறிய உதவும்!',
  },
  settings: {
    appSettings: 'பயன்பாட்டு அமைப்புகள்',
    appSettingsDesc: 'உங்கள் Duri  அனுபவத்தை தனிப்பயனாக்கவும் மற்றும் தனியுரிமை விருப்பங்களை நிர்வகிக்கவும்.',
    languageRegion: 'மொழி & பகுதி',
    languagePrompt: 'எந்த மொழியை விரும்புகிறீர்கள்?',
    timezone: 'நேர மண்டலம்',
    currency: 'நாணயம்',
    appPermissions: 'பயன்பாட்டு அனுமதிகள்',
    appPermissionsDesc: 'இந்த அனுமதிகள் உங்களுக்கு சிறந்த பயண அனுபவத்தை வழங்க உதவுகின்றன. நீங்கள் இவை எப்போது வேண்டுமானாலும் மாற்றலாம்.',
    locationAccess: 'இருப்பிடம் அணுகல்',
    locationAccessDesc: 'அருகிலுள்ள பயணங்களை காண்பிக்கவும் மற்றும் வழிகாட்டுதலை வழங்கவும்',
    readSmsOtp: 'SMS/OTP ஐ படிக்கவும்',
    readSmsOtpDesc: 'விரைவான சரிபார்ப்பிற்கு OTP குறியீடுகளை தானாக நிரப்பவும்',
    phoneCalls: 'தொலைபேசி அழைப்புகள்',
    phoneCallsDesc: 'ஒத்துழைப்பிற்காக பயணிகள்/ஓட்டுநர்களை அழைக்க அனுமதிக்கவும்',
    notifications: 'அறிவிப்புகள்',
    notificationsDesc: 'உங்கள் பயணங்கள் மற்றும் Duri  செய்திகள் குறித்து எவ்வாறு புதுப்பிக்கப்பட வேண்டும் என்பதைத் தேர்ந்தெடுக்கவும்.',
    pushNotifications: 'புஷ் அறிவிப்புகள்',
    pushNotificationsDesc: 'பயண புதுப்பிப்புகள், செய்திகள் மற்றும் முக்கிய அறிவிப்புகள்',
    emailNotifications: 'மின்னஞ்சல் அறிவிப்புகள்',
    emailNotificationsDesc: 'மின்னஞ்சல் மூலம் பயண உறுதிப்பாடுகள் மற்றும் ரசீதுகள்',
    smsNotifications: 'SMS அறிவிப்புகள்',
    smsNotificationsDesc: 'முக்கிய பயண புதுப்பிப்புகள் குறுஞ்செய்தி மூலம்',
    rideReminders: 'பயண நினைவூட்டல்கள்',
    rideRemindersDesc: 'வரவிருக்கும் பயணங்களை நினைவூட்டல்கள்',
    promotionalUpdates: 'விளம்பர புதுப்பிப்புகள்',
    promotionalUpdatesDesc: 'சிறப்பு சலுகைகள் மற்றும் புதிய அம்சங்கள்',
    saveSettings: 'அமைப்புகளை சேமிக்கவும்',
  },
  header: {
    home: 'முகப்பு',
    findRide: 'பயணத்தை கண்டறியவும்',
    offerRide: 'பயணத்தை வழங்கவும்',
    manageRides: 'பயணங்களை நிர்வகிக்கவும்',
    account: 'கணக்கு',
    logout: 'வெளியேறு',
    aiAssistant: 'Duri  AI உதவியாளர்',
    findPerfectRideMatch: 'உங்களுக்கு சிறந்த பயணத்தை கண்டறியவும்',
    connectWithTravelers: 'உங்கள் பாதையில் பயணிகளுடன் இணைக்கவும்',
    askAiFindingRides: 'பயணங்களை கண்டறிய AI-யை கேளுங்கள்...',
    askAiOfferingRides: 'பயணங்களை வழங்க AI-யை கேளுங்கள்...',
    findRidesToBandra: 'பாண்டிராவுக்கு பயணங்களை கண்டறியவும்',
    cheapestRouteToAirport: 'விமான நிலையத்திற்கு மலிவான பாதை',
    dailyCommuteToPowai: 'பொவைக்கு தினசரி பயணம்',
    postRideToGurgaon: 'குர்கானுக்கு பயணத்தை பதிவிடவும்',
    setRecurringRoute: 'மீண்டும் நடைபெறும் பாதையை அமைக்கவும்',
    managePassengers: 'பயணிகளை நிர்வகிக்கவும்',
    benefits: 'நன்மைகள்',
  howItWorks: 'இது எப்படி செயல்படுகிறது',
  findARide: 'ரைடை கண்டறியவும்',
  safety: 'பாதுகாப்பு',
  support: 'ஆதரவு',
  login: 'உள்நுழை',
  getStarted: 'தொடங்குங்கள்',
  },
  footer: {
    downloadAppTitle: 'Duri பதிவிறக்கவும்',
    downloadAppDesc: 'சிறந்த அனுபவத்திற்கு மொபைல் பயன்பாட்டை பெறுங்கள், நேரடி கண்காணிப்பு, உடனடி அறிவிப்புகள் மற்றும் எளிதாக பயணம் முன்பதிவு. அனைத்து சாதனங்களிலும் இலவசமாக கிடைக்கும்.',
    getItOn: 'இதில் பெறவும்',
    googlePlay: 'கூகுள் பிளே',
    downloadOnThe: 'பதிவிறக்கவும்',
    appStore: 'ஆப் ஸ்டோர்',
    scanForAndroid: 'Android-க்கு ஸ்கேன் செய்யவும்',
    scanForIOS: 'iOS-க்கு ஸ்கேன் செய்யவும்',
    googlePlayStore: 'கூகுள் பிளே ஸ்டோர்',
    appleAppStore: 'ஆப்பிள் ஆப் ஸ்டோர்',
    brandDesc: 'சிறந்த, பாதுகாப்பான மற்றும் நிலையான பயண பகிர்வை உலகம் முழுவதும் பயணிகளை இணைக்கிறது. பயணத்தை மேம்படுத்திய மில்லியன் கணக்கானவர்களில் சேரவும், பணத்தை சேமிக்கவும் மற்றும் எங்கள் கிரகத்தை பாதுகாக்கவும்.',
    contactEmail: 'contact@hansaitechnosoft.com',
    contactPhone: '+91 76809 38741',
    contactHours: 'Available hrs: 8 AM to 10 PM IST',
    availableCountries: '25+ நாடுகளில் கிடைக்கும்',
    sectionCompany: 'நிறுவனம்',
    sectionGuests: 'விருந்தினருக்கு',
    sectionHosts: 'ஹோஸ்ட்களுக்கு',
    sectionTravelers: 'பயணிகளுக்காக',
    sectionSupport: 'உதவி மற்றும் ஆதரவு',
    sectionLegal: 'சட்டம் மற்றும் இணக்கம்',
    sectionCountries: 'கிடைக்கும் நாடுகள்',
    companyLinks: {
      aboutUs: 'எங்களை பற்றி',
      news: 'செய்திகள் & புதுப்பிப்புகள்',
      howItWorks: 'இது எப்படி செயல்படுகிறது',
      safety: 'பாதுகாப்பு',
      careers: 'வேலைவாய்ப்புகள்',
      press: 'பத்திரிகை',
      duriGreenMobility: 'டூரி கிரீன் மொபிலிட்டி',
    },
    guestLinks: {
      howToBook: 'ரைடை எப்படி பதிவு செய்வது?',
      findARide: 'ரைடை கண்டறியவும்',
      availableRides: 'கிடைக்கும் ரைடுகள்',
      searchByRideId: 'ரைடு Id மூலம் தேடவும்',
      searchByRider: 'ரைடர் மூலம் தேடவும்',
      howToBookGuide: 'ரைடை எப்படி பதிவு செய்வது',
      howToDailyCommute: 'தினசரி பயணம் எப்படி',
      commuteCalculator: 'கம்யூட் கால்குலேட்டர் (விருந்தினர்)',
    },
    hostLinks: {
      howToHost: 'ரைடை எப்படி ஹோஸ்ட் செய்வது?',
      rideRequests: 'ரைடு கோரிக்கைகள்',
      lookUpARide: 'ரைடை பார்க்கவும்',
      howToDailyCommute: 'தினசரி பயணம் எப்படி',
      popularRoutes: 'பிரபலமான ரைடுகள்',
      commuteCalculator: 'கம்யூட் கால்குலேட்டர் (ஹோஸ்ட்)',
    },
    travelersLinks: {
      findRides: 'பயணங்களை கண்டறியவும்',
      offerRides: 'பயணங்களை வழங்கவும்',
      mobileApp: 'மொபைல் பயன்பாடு',
      referFriends: 'நண்பர்களை பரிந்துரைக்கவும்',
      helpCenter: 'உதவி மையம்'
    },
    supportLinks: {
      customerSupport: 'வாடிக்கையாளர் ஆதரவு',
      safetyGuidelines: 'பாதுகாப்பு வழிகாட்டிகள்',
      trustSafety: 'நம்பிக்கை & பாதுகாப்பு',
      insurance: 'காப்பீடு',
      contactUs: 'எங்களை தொடர்பு கொள்ளவும்',
      getHelp: 'உதவி பெறவும்',
      reportIssue: 'சிக்கலைப் புகாரளிக்கவும்',
      myIssues: 'என் சப்போர்ட் டிக்கெட்டுகள்',
      whatsappSupport: 'WhatsApp ஆதரவு',
      corporateCarpool: 'கார்ப்பரேட் கார்பூல்',
    },
    legalLinks: {
      termsOfService: 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
      privacyPolicy: 'தனியுரிமை கொள்கை',
      cookiePolicy: 'குக்கீ கொள்கை',
      refundPolicy: 'ரத்துசெய் கொள்கை',
      deleteAccount: 'கணக்கை நீக்கு',
      tripInsurance: 'பயண காப்பீடு',
      paymentTerms: 'கட்டண விதிமுறைகள் மற்றும் நிபந்தனைகள்',
      communityGuidelines: 'சமூக வழிகாட்டிகள்'
    },
    copyright: '© 2025 Duri. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
    copyrightText: '@{year} HansAI Techno Soft Private Limited, அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை'
  },
  quickRideFinder: {
    currentLocationDetected: '📍 தற்போதைய இடம் கண்டறியப்பட்டது',
    greeting1: '👋 வணக்கம்! நீங்கள் {location} இல் இருக்கிறீர்கள்.',
    greeting2: 'இன்று நீங்கள் எங்கு செல்ல விரும்புகிறீர்கள்?',
    letsFindRide: 'வண்டியை கண்டுபிடிப்போம்! ✨',
    destinationPrompt: '🎯 சிறப்பு! நாம் எங்கு செல்ல வேண்டும்?',
    destinationSubPrompt: 'உங்கள் இலக்கை டைப் செய்யவும் அல்லது கீழே உள்ள பிரபலமானவற்றில் ஒன்றை தேர்வு செய்யவும்',
    destinationPlaceholder: 'எ.கா., புனே, டெல்லி, பெங்களூரு...',
    nextWhen: 'அடுத்து: எப்போது? →',
    datePrompt: '📅 சிறந்த தேர்வு! {from} இருந்து {to}',
    dateSubPrompt: 'நீங்கள் எப்போது பயணம் செய்ய விரும்புகிறீர்கள்?',
    nextPassengers: 'அடுத்து: எத்தனை பயணிகள்? →',
    passengersPrompt: '👥 இன்னும் கொஞ்சம்! எத்தனை பயணிகள்?',
    passengersSubPrompt: 'உங்களை உட்பட',
    perfectFindRides: 'சிறப்பு! வண்டிகளை கண்டுபிடிப்போம் →',
    readyTitle: '🎉 தேட தயாராக இருக்கிறது!',
    from: 'இருந்து:',
    to: 'வரை:',
    date: 'தேதி:',
    passengers: 'பயணிகள்:',
    person: 'நபர்',
    people: 'நபர்கள்',
    findMyPerfectRide: 'என் சிறந்த வண்டியை கண்டுபிடிக்கவும்!',
      popularRoutes: 'மும்பை இலிருந்து பிரபலமான வழிகள்',  // '{city} இலிருந்து பிரபலமான வழிகள்',
    today: 'இன்று',
    tomorrow: 'நாளை',
    thisWeekend: 'இந்த வார இறுதி',
  },
  hero: {
    badge: 'எங்கள் சரிபார்க்கப்பட்ட பயணப் பகிர்வு தளத்தில் 10 மில்லியனுக்கும் மேற்பட்ட விருந்தினர்களின் நம்பிக்கை',
    mainTitle: 'பயணத்தை பகிரவும், சேமிக்கவும்',
    mainTitleHighlight: 'பணமும், பூமியும்',
    subtitle: 'மிகவும் நம்பகமான நகரங்களுக்கு இடையிலான பயணப் பகிர்வு பயன்பாட்டில் சேருங்கள் — உங்கள் பயணத்தைப் பகிருங்கள், மேலும் சேமிக்கவும், புத்திசாலித்தனமாகப் பயணிக்கவும்.',
    findRide: 'பயணத்தை கண்டுபிடிக்கவும்',
    offerRide: 'பயணத்தை வழங்கவும்',
    statSaved: 'மொத்த சேமிப்பு',
    statCO2: 'CO₂ டன் குறைப்பு',
    statHappy: 'மகிழ்ச்சியான பயணங்கள்',
  },
  benefits: {
    badge: 'ஏன் Duri?',
    sectionTitle: 'உங்களுக்கு தேவையான அனைத்தும்',
    sectionSubtitle: 'சிறந்த, பாதுகாப்பான மற்றும் நிலையான பயணத்திற்கு.',
    saveMoneyTitle: 'பணம் சேமிக்கவும்',
    saveMoneyDesc: 'குறைந்த செலவு பயணப் பகிர்வு விருப்பங்களுடன் பட்ஜெட் பயணத்தை அனுபவிக்கவும், இது செலவுகளை 70% வரை குறைக்கிறது',
    saveMoneyStats: 'சராசரி வருடத்திற்கு ₹15,000 சேமிப்பு',
    helpPlanetTitle: 'பூமியை பாதுகாக்கவும்',
    helpPlanetDesc: 'ஒவ்வொரு பகிரப்பட்ட பயணப் பயன்பாட்டு பயணத்துடனும் CO₂-ஐ குறைத்து, ஒரு பசுமையான பயணத் தீர்வைத் தேர்ந்தெடுக்கவும்',
    helpPlanetStats: '100கிமீக்கு 2.3 கிலோ CO₂ சேமிப்பு',
    travelSafeTitle: 'பாதுகாப்பாக பயணிக்கவும்',
    travelSafeDesc: 'சரிபார்க்கப்பட்ட ஹோஸ்ட்களும் நேரடி பயண கண்காணிப்பும் கொண்ட நம்பகமான கார்‌பூல் பயன்பாடு',
    travelSafeStats: '99.8% விபத்து இல்லாத பயணங்கள்',
    anyTimeTitle: 'எப்போது வேண்டுமானாலும்',
    anyTimeDesc: 'எங்கள் நேரடி வழிகாட்டி பயன்பாட்டின் மூலம் எப்போது வேண்டுமானாலும் நகரத்திலிருந்து நகரத்திற்கு பயணங்களை அணுகுங்கள்',
    anyTimeStats: 'எப்போதும் கிடைக்கும்',
    meetPeopleTitle: 'மக்களை சந்திக்கவும்',
    meetPeopleDesc: 'எங்கள் வளர்ந்து வரும் பயணப் பகிர்வு சமூகத்தின் மூலம் இணைந்து சேர்ந்து பயணிக்கவும்',
    meetPeopleStats: '85% பயனர்கள் புதிய நண்பர்களை பெற்றுள்ளனர்',
    goAnywhereTitle: 'எங்கே வேண்டுமானாலும் செல்லுங்கள்',
    goAnywhereDesc: 'பல நாடுகளில் 500+ இடங்களுக்கு அணுகல்',
    goAnywhereStats: 'உலகம் முழுவதும் 500+ நகரங்கள்',
  },
  statistics:{
    sectionTitle: "எங்கள் புள்ளிவிவரங்கள்",
  sectionSubtitle: "உலகம் முழுவதும் பயணிகளுக்கு நாங்கள் ஏற்படுத்தும் தாக்கத்தை காணுங்கள்.",
  travelersLabel: "பயணிகள்",
  travelersDesc: "எங்களை நம்புகிறவர்கள்",
  citiesLabel: "நகரங்கள்",
  citiesDesc: "நாங்கள் சேவை செய்கிறோம்",
  savedLabel: "மொத்த சேமிப்பு",
  savedDesc: "பயண செலவில்",
  co2Label: "CO₂ குறைப்பு",
  co2Desc: "வெளியேற்றம் குறைப்பு — மிகச் சிறந்த கார்பன் சேமிப்பு பயணத் தீர்வு",
  costReductionLabel: "செலவு குறைப்பு",
  costReductionSuffix: "% குறைந்த செலவு",
  emissionReductionLabel: "வாயு வெளியீடு குறைப்பு",
  emissionReductionSuffix: "% குறைந்த CO₂",
  userSatisfactionLabel: "பயனர் திருப்தி",
  userSatisfactionSuffix: "% மகிழ்ச்சியானவர்கள்",
  safetyRateLabel: "பாதுகாப்பு விகிதம்",
  safetyRateSuffix: "% பாதுகாப்பு விகிதம்"
  },
  safety:{
    badge: "பாதுகாப்பு",
  sectionTitle: "உங்கள்",
  sectionTitleHighlight: "பாதுகாப்பு எங்கள் முன்னுரிமை",
  sectionSubtitle: "பாதுகாப்பான பயணம், நம்பகமான மற்றும் பொருந்தக்கூடிய பயண அனுபவங்களை உறுதி செய்ய எங்கள் நம்பகமான பயணப் பகிர்வு பயன்பாட்டில் ஒவ்வொரு பயனரும் சரிபார்க்கப்பட்டுள்ளனர்.",
  backgroundVerified: "பின்னணி சரிபார்ப்பு",
  safeRidesCompleted: "பாதுகாப்பான பயணங்கள்",
  trustScoreAverage: "நம்பிக்கை மதிப்பீடு சராசரி",
  emergencyResponse: "அவசர பதில்",
  idVerificationTitle: "அடையாள சரிபார்ப்பு",
  idVerificationDesc: "ஒவ்வொரு பயணியும் ஓட்டுநரும் அடையாளம் சரிபார்க்கப்படுவார்கள்.",
  idVerificationStats: "100% KYC முடிந்தது",
  professionalTitle: "தொழில்முறை ஓட்டுநர்கள்",
  professionalDesc: "அனுபவமுள்ள மற்றும் பயிற்சி பெற்ற ஓட்டுநர்கள் மட்டுமே.",
  professionalStats: "90% ஓட்டுநர்கள் தொழில்முறை",
  cultureTitle: "பண்பாட்டு பல்வகைமை",
  cultureDesc: "விவித பின்னணியிலிருந்து பயணிகள் மற்றும் ஓட்டுநர்கள்.",
  cultureStats: "30+ மொழிகள் பேசுபவர்கள்",
  interestsTitle: "பொது விருப்பங்கள்",
  interestsDesc: "உங்கள் விருப்பங்களுக்கு ஏற்ப பயண கூட்டாளிகள்.",
  interestsStats: "80% பொருத்தம்",
  trackingTitle: "நேரடி கண்காணிப்பு",
  trackingDesc: "ஒவ்வொரு பயணத்திற்கும் நேரடி ரைடு கண்காணிப்பு மற்றும் ஸ்மார்ட் மோபிலிட்டி சால்யூஷன்களுடன் பாதுகாப்பாக இருக்கவும்.",
  trackingStats: "24/7 கண்காணிப்பு",
  secureCommTitle: "பாதுகாப்பான தொடர்பு",
  secureCommDesc: "சரிபார்க்கப்பட்ட ஹோஸ்ட்கள் மற்றும் விருந்தினர்களுக்கான எங்கள் பயன்பாட்டில் பாதுகாப்பான தொடர்பை அனுபவிக்கவும் — தனியுரிமை காப்பாற்றப்படும்.",
  secureCommStats: "முடிவில் முடிவு குறியாக்கம்",
  ctaTitle: "எங்கள் பாதுகாப்பு தரங்களை அனுபவிக்கவும்",
  ctaDesc: "நீங்கள் பயணிக்கும்போது உங்கள் பாதுகாப்பை நாங்கள் உறுதி செய்கிறோம்.",
  ctaButton: "இப்போது சேரவும்"
  },
  howItWorks: {
  sectionTitle: "இது எப்படி செயல்படுகிறது?",
  sectionSubtitle: "உங்கள் பயண அனுபவத்தை மாற்றும் நான்கு எளிய படிகள் — ஹோஸ்ட் ஆக.",
  searchTitle: "உங்கள் ரைடு சேர்க்கவும்",
  searchDesc: "சில கிளிக்குகளில் உங்கள் காலியாக உள்ள இருக்கைகள் மற்றும் பாதைகளை கெஸ்ட்க்கு வழங்குங்கள்.",
  connectTitle: "இணையுங்கள்",
  connectDesc: "புக்கிங்க்களை உறுதிப்படுத்தவும், பயணத்தை சீராக செய்யவும் கெஸ்ட் உடன் தொடர்பு கொள்ளுங்கள்.",
  payTitle: "சம்பாதிக்கவும்",
  payDesc: "ஒவ்வொரு பகிர்ந்த ரைடுக்கும் பாதுகாப்பாக சம்பாதிக்கவும், உங்கள் வாகனத்தின் பயன்பாட்டை அதிகப்படுத்தவும்.",
  travelTitle: "டிரைவ் செய்யவும்",
  travelDesc: "ரியல்-டைம் ட்ராக்கிங் மற்றும் கெஸ்ட் ரேட்டிங்ஸ் போன்ற அம்சங்களுடன் பாதுகாப்பான, நம்பகமான ரைடுகளை வழங்குங்கள்.",
  GuestsectionSubtitle: 'உங்கள் பயண அனுபவத்தை மாற்றும் நான்கு எளிய படிகள் — கெஸ்ட் ஆக.',
  GuestsearchTitle:'தேடுங்கள்',
  GuestsearchDesc:'உங்கள் பாதை மற்றும் அட்டவணைக்கேற்ற, சான்றளிக்கப்பட்ட ஹோஸ்ட்கள் வழங்கிய ரைடுகளை எளிதில் கண்டறியுங்கள்.',
  GuestconnectTitle:'இணையுங்கள்',
  GuestconnectDesc:'பிக்-அப் பாயிண்டுகள் மற்றும் பயண விவரங்களை பாதுகாப்பாக ஒத்திசைக்க ஹோஸ்ட் உடன் நேரடியாக சந்திக்கவும்.',
  GuestpayTitle:'பணம் செலுத்துங்கள்',
  GuestpayDesc:'உங்கள் ரைட்களை முன்பதிவு செய்து, செலவுகளை எளிதில் பகிர்ந்து, பாதுகாப்பாக பணம் செலுத்துங்கள்.',
  GuesttravelTitle:'பயணியுங்கள்',
  GuesttraveDesc:'ரியல்-டைம் டிராக்கிங் மற்றும் ரைட் ஆதரவுடன் வசதியான, பாதுகாப்பான பயணத்தை அனுபவிக்கவும்.'
  },
  testimonials: {
    sectionTitle: 'எங்கள் சமூகத்தின் கதைகள்',
    sectionSubtitle: "பகிர்ந்த பயணத்தின் மகிழ்ச்சியை கண்டுபிடித்த பயணிகளின் உண்மையான அனுபவங்கள்.",
    averageRating: 'சராசரி மதிப்பீடு',
    recommendUs: 'எங்களை பரிந்துரைக்கிறார்கள்',
    happyTravelers: 'மகிழ்ச்சியான பயணிகள்',
    customerSupport: 'வாடிக்கையாளர் ஆதரவு',
    trustedBy: 'பணியாளர்களால் நம்பப்படுகிறது',
    items: [
      JSON.stringify({
        name: 'பிரியா சர்மா',
        role: 'மென்பொருள் பொறியாளர்',
        location: 'மும்பை → புனே வழி',
        rating: 5,
        text: "கடந்த 6 மாதங்களில் என் வாராந்திர மும்பை-புனே பயணங்களுக்கு ரைடு ஷேரிங் பயன்படுத்தி நான் ₹8,000 க்கும் மேலாக சேமித்துள்ளேன். இந்த பயன்பாடு சரிபார்க்கப்பட்ட ஹோஸ்ட்களும் எளிய முன்பதிவும் கொண்ட மிகவும் நம்பகமான கார் புல் பயன்பாடாகும்.",
        avatar: '👩‍💼',
        savings: '₹8,000 சேமிப்பு'
      }),
      JSON.stringify({
        name: 'ராஜ் படேல்',
        role: 'வணிக உரிமையாளர்',
        location: 'டெல்லி → ஜெய்ப்பூர் வழி',
        rating: 5,
        text: "நான் மாதம் இருமுறை ஜெய்ப்பூர் செல்லும் ஒருவர். இந்த தளம் எனக்கு மிகுந்த உதவியாக உள்ளது. சிறந்த நண்பர்கள், நம்பகமான சேவை, சூழலுக்கும் உதவுகிறேன்!",
        avatar: '👨‍💼',
        savings: '60% செலவு குறைப்பு'
      }),
      JSON.stringify({
        name: 'அனிதா ரெட்டி',
        role: 'கல்லூரி மாணவி',
        location: 'பெங்களூரு → சென்னை வழி',
        rating: 5,
        text: "தினசரி பயண செலவுகளைச் சேமிக்க குறைந்த செலவு பயணப் பயன்பாட்டைக் கண்டுபிடிக்கும் மாணவர்கள் மற்றும் தொழில்முனைவோர்களுக்கு ஏற்றது. பாதுகாப்பு அம்சங்கள் என் பெற்றோருக்கு நிம்மதி அளிக்கின்றன, நல்ல நண்பர்களும் கிடைத்தனர்.",
        avatar: '👩‍🎓',
        savings: 'வருடத்திற்கு ₹12,000 சேமிப்பு'
      }),
      JSON.stringify({
        name: 'விக்ரம் சிங்',
        role: 'மார்க்கெட்டிங் மேலாளர்',
        location: 'ஹைதராபாத் → விஜயவாடா வழி',
        rating: 5,
        text: "சக பயணிகளின் தரம் சிறந்தது. அர்த்தமுள்ள உரையாடல்கள், வணிக நெட்வொர்க்கிங் வாய்ப்புகளும் கிடைத்தன. இது வெறும் பண சேமிப்பு மட்டும் அல்ல.",
        avatar: '👨‍💻',
        savings: 'புதிய தொடர்புகள்'
      })
    ]
  },
  topBar:{
  welcomeMessage: "டூரி ரைட்ஷேரிங்கிற்கு வரவேற்கிறோம் — சரிபார்க்கப்பட்ட விருந்தினர்களும் ஹோஸ்ட்களும் உடன் பாதுகாப்பான, நம்பகமான பயணம்.",
  },
};
export default ta; 